// extracted by mini-css-extract-plugin
module.exports = {"debug":"title_debug__2g6L4","titleContainer":"title_titleContainer__3ioBT","titleContent":"title_titleContent__1eRMB"};